import http from "../../http";

const guideProfit = {

    saveGuideProfit(r) {
        return http.confirm.payload("/gateway/api/sycompany/pc/guideProfitPC/saveGuideProfit", r)
    },
    selectGuideProfitPage(r) {
        return http.spin.get("/gateway/api/sycompany/pc/guideProfitPC/selectGuideProfitPage", r)
    },
    deleteGuideProfit(r) {
        return http.confirm.post("/gateway/api/sycompany/pc/guideProfitPC/deleteGuideProfit", r)
    },
    selectByProfitId(r) {
        return http.spin.get("/gateway/api/sycompany/pc/guideProfitPC/selectByProfitId", r)
    },



}
export default guideProfit
